// One-shot handoff for the dashboard's "Play" quick action: it knows which
// time control the user picked before PlayChess (and its socket) even
// mounts, but there's nowhere to put that except here — GameSearch reads it
// once on mount instead of the caller shipping it as navigation params.
let pending: {control: string} | null = null;

export function setPendingAutoJoin(control: string) {
  pending = {control};
}

export function consumePendingAutoJoin(): {control: string} | null {
  const value = pending;
  pending = null;
  return value;
}

/**
 * Non-consuming read, for PlayChessSwitch's flow resolution: it must know
 * whether an auto-join is pending BEFORE deciding which lane renders, but the
 * screen that actually joins (GameSearch) still needs to consume it.
 */
export function peekPendingAutoJoin(): {control: string} | null {
  return pending;
}
